import i18next from 'i18next';

export const translate = (
    translateFile: string = 'common',
    translateStr: string,
) => i18next.t(`${translateFile}:${translateStr}`);
